(function () {
  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', 'true');
    var steps = root.querySelectorAll('[data-lux-step]');
    var images = root.querySelectorAll('[data-lux-img]');
    if (!steps.length || !images.length || !('IntersectionObserver' in window)) return;

    function show(index) {
      Array.prototype.forEach.call(images, function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-lux-img') === index);
      });
      Array.prototype.forEach.call(steps, function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-lux-step') === index);
      });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) show(entry.target.getAttribute('data-lux-step'));
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

    Array.prototype.forEach.call(steps, function (s) { io.observe(s); });
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lux-story]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
